import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../../../../redux/connect';
import {
  getCurrentDocument,
  getOxygenMappings,
  getActiveUsers,
  getDocumentCollection,
  getCurrentViewType, getImpacts,
} from '../../../../../../redux/selectors';
import { toOptionsArray } from "../../../../../../utils/parsing-helpers";
import classNames from 'classnames';
import IssueFieldInlineEdit from '../../../../../IssueFieldInlineEdit';
import UserOnlyAssignedToInlineEdit from './components/UserOnlyAssignedToInlineEdit';
import DueDateToInlineEdit from './components/DueDateToInlineEdit';
import LocationDescriptionInlineEdit from '../../../../../LocationDescriptionInlineEdit';
import LinkedDocumentInlineEdit from '../LinkedDocumentInlineEdit';
import CoReviewersInlineEdit from './components/CoReviewersInlineEdit';
import { issueAttributesType, oxygenType } from '../../../../../../constants/proptype-validation';
import { viewTypes } from '../../../../../../constants/view-types';
import { ISSUE_ATTRIBUTE_NAMES } from '../../../../../../constants/issue-attribute-names';
import {
  ISSUES_PREVIEW_FIELD_NAMES,
  PANELS,
} from '../../../../../../constants/issuePreview';
import SingleSelectInlineEdit from "../../../../../SingleSelectInlineEdit";
import T from "i18n-react";

class IssuePreviewDetailsTabGeneralSection extends PureComponent {
  constructor(props) {
    super(props);

    this.renderAttribute = this.renderAttribute.bind(this);
  }

  renderAttribute(attributeName) {
    const { issue, impactOptions } = this.props;

    switch (attributeName) {
      case ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO: {
        const { oxygen } = this.props;
        return (
          <UserOnlyAssignedToInlineEdit
            key={ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO}
            issue={issue}
            oxygen={oxygen}
            className="IssuePreviewDetailsTabGeneralSection__field"
            styleType={IssueFieldInlineEdit.StyleTypes.SMALL}
            data-testid="AssignedToInlineEdit"
          />
        );
      }
      case ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS: {
        const { users, container } = this.props;

        return (
          <CoReviewersInlineEdit
            key={ISSUE_ATTRIBUTE_NAMES.CO_REVIEWERS}
            issue={issue}
            users={users}
            container={container}
            className="IssuePreviewDetailsTabGeneralSection__field"
            styleType={IssueFieldInlineEdit.StyleTypes.SMALL}
          />
        );
      }
      case ISSUE_ATTRIBUTE_NAMES.DUE_DATE:
        return (
          <DueDateToInlineEdit
            key={ISSUE_ATTRIBUTE_NAMES.DUE_DATE}
            issue={issue}
            className="IssuePreviewDetailsTabGeneralSection__field"
            styleType={IssueFieldInlineEdit.StyleTypes.SMALL}
          />
        );
      case ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION:
        return (
          <LocationDescriptionInlineEdit
            key={ISSUE_ATTRIBUTE_NAMES.LOCATION_DESCRIPTION}
            issue={issue}
            className="IssuePreviewDetailsTabGeneralSection__field"
            styleType={IssueFieldInlineEdit.StyleTypes.SMALL}
          />
        );
      case ISSUE_ATTRIBUTE_NAMES.TARGET_URN: {
        const { container } = this.props;

        return (
          <LinkedDocumentInlineEdit
            key={ISSUE_ATTRIBUTE_NAMES.TARGET_URN}
            issue={issue}
            container={container}
            className="IssuePreviewDetailsTabGeneralSection__field"
          />
        );
      }
      case ISSUE_ATTRIBUTE_NAMES.SCHEDULE: {
        return <div className="IssuePreviewDetailsTabGeneralSection__field">
          <SingleSelectInlineEdit issue={issue} attributeName={ISSUE_ATTRIBUTE_NAMES.SCHEDULE} label={T.translate('new.scheduleImpact')} options={impactOptions} />
        </div>;
      }
      case ISSUE_ATTRIBUTE_NAMES.COST: {
        return <div className="IssuePreviewDetailsTabGeneralSection__field">
          <SingleSelectInlineEdit issue={issue} attributeName={ISSUE_ATTRIBUTE_NAMES.COST} label={T.translate('new.costImpact')} options={impactOptions} />
        </div>;
      }
      default:
        return null;
    }
  }

  render() {
    const { viewType } = this.props;
    const divClassNames = classNames('IssuePreviewDetailsTabGeneralSection', {
      'IssuePreviewDetailsTabGeneralSection__narrow': viewType === viewTypes.DOCUMENT,
      'IssuePreviewDetailsTabGeneralSection__wide': viewType === viewTypes.PROJECT,
    });

    return (
      <form className={divClassNames}>
        <div className="IssuePreviewDetailsTabGeneralSection__first-panel">
          {ISSUES_PREVIEW_FIELD_NAMES[PANELS.FIRST_PANEL].map(this.renderAttribute)}
        </div>
        <div className="IssuePreviewDetailsTabGeneralSection__second-panel">
          {ISSUES_PREVIEW_FIELD_NAMES[PANELS.SECOND_PANEL].map(this.renderAttribute)}
        </div>
      </form>
    );
  }
}

IssuePreviewDetailsTabGeneralSection.displayName = 'IssuePreviewDetailsTabGeneralSection';

IssuePreviewDetailsTabGeneralSection.propTypes = {
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
  oxygen: oxygenType.isRequired,
  users: PropTypes.array.isRequired,
  container: PropTypes.object.isRequired,
  impactOptions: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    document: getCurrentDocument(state),
    oxygen: getOxygenMappings(state),
    users: getActiveUsers(state),
    documentCollection: getDocumentCollection(state),
    viewType: getCurrentViewType(state),
    impactOptions: toOptionsArray(getImpacts(state)),
  };
};

export default connect(mapStateToProps)(IssuePreviewDetailsTabGeneralSection);
